import React, { useEffect } from 'react';
import { Query } from 'react-apollo';
import Button from '@material-ui/core/Button';

import Stars from '../stars/stars';
import Section from '../section/section';
import Stepper from '../stepper/stepper';
import ReadMore from '../read-more/read-more';

import classes from './baker-profile.module.scss';
import { GET_PRODUCTS_BY_BAKER, GET_BAKER } from '../../queries';
import { CircularProgress } from '@material-ui/core';
import ProductList from '../product-list/product-list';
import { navigate } from '@reach/router';

const mockReviews = [
  {
    name: 'Таня',
    city: 'Одеса',
    img: '/assets/girl.png',
    text: `I've ordered macarons with different tastes. They are all perfect. But my favourite is still matcha.`
  },
  {
    name: 'Катя',
    city: 'Львів',
    img: '/assets/girl2.png',
    text: `Anna's macarons are perfect. One love <3`
  }
];

interface ISingleReview {
  name: string;
  city: string;
  img: string;
  text: string;
}

const BakerProfile: any = (props: any) => {
  const showAllProducts = new URLSearchParams(props.location.search).get('all');
  useEffect(() => window.scrollTo(0, 0));
  const username = props.baker;

  const SingleReview = ({ name, city, img, text }: ISingleReview) => (
    <div className={classes.singleReview}>
      <img src={img} alt="reviewer" />
      <div>
        <h5>
          {name}, {city}
        </h5>
        <ReadMore text={text} size={70} />
      </div>
    </div>
  );

  return (
    <div className={classes.root}>
      <Query query={GET_BAKER} variables={{ username }}>
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div style={{ textAlign: 'center' }}>
                <CircularProgress />
              </div>
            );
          }
          if (error) return <div>Error fetching bakers</div>;

          const { user } = data;
          return (
            <>
              <div className={classes.profileInfoBox}>
                <div className={classes.profileInfoMain}>
                  <img src={user.image || '/assets/profile_default.png'} />
                  <div className={classes.bio}>
                    <h3 data-e2e-id={'baker-name'}>{user.firstName}</h3>
                    {showAllProducts ? null : <h5>Львів</h5>}
                    <Stars stars={user.stars} reviews={user.reviews} />
                    {showAllProducts ? (
                      <h3
                        className={classes.readMore}
                        onClick={() => navigate(props.uri)}
                      >
                        Більше про пекаря
                      </h3>
                    ) : (
                      <ReadMore text={user.bio} size={100} />
                    )}
                  </div>
                </div>
                {showAllProducts ? null : (
                  <div className={classes.profileInfoFooter}>
                    <div className={classes.social}>
                      <a>
                        <img
                          src="/assets/social/facebook-logo.svg"
                          alt="facebook-logo"
                        />
                      </a>
                      <a>
                        <img
                          src="/assets/social/instagram-logo.svg"
                          alt="instagram-logo"
                        />
                      </a>
                      <a>
                        <img
                          src="/assets/social/youtube-symbol.svg"
                          alt="youtube-logo"
                        />
                      </a>
                    </div>
                    <Button
                      variant="contained"
                      color="primary"
                      data-e2e-id={'send-button'}
                      className={classes.writeButton}
                    >
                      Написати
                    </Button>
                  </div>
                )}
              </div>
              {showAllProducts ? null : mockReviews ? (
                <Section title="Відгуки про пекаря" count={mockReviews.length}>
                  {mockReviews.map(review => (
                    <SingleReview key={review.city} {...review} />
                  ))}
                  <h3 className={classes.moreReviews}>Більше відгуків</h3>
                </Section>
              ) : null}
            </>
          );
        }}
      </Query>
      <Query query={GET_PRODUCTS_BY_BAKER} variables={{ bakerId: username }}>
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div style={{ textAlign: 'center' }}>
                <CircularProgress />
              </div>
            );
          }
          if (error) return <div>Error fetching products</div>;

          const { productsByBaker: products } = data;
          if (products.length) {
            const productsWithOneImage = products.map((product: any) => ({
              ...product,
              image: product.imagesUrls[0]
            }));
            return (
              <Section
                title={'Пропозиції цього пекаря'}
                count={products.length}
                click={() => navigate(`${props.uri}?all=true`)}
              >
                {showAllProducts ? (
                  <ProductList products={productsWithOneImage} />
                ) : (
                  <Stepper steps={productsWithOneImage} />
                )}
              </Section>
            );
          } else {
            return null;
          }
        }}
      </Query>
    </div>
  );
};

export default BakerProfile;
